import r from "./_tagTester.js";
var t = r("String");
export { t as default };